export function combineUrl(base, ...paths) {
    if (base.endsWith('/')) {
        base = base.slice(0, -1);
    }
    paths = paths.map((path) => {
        if (path.startsWith('/')) {
            path = path.substring(1);
        }
        if (path.endsWith('/')) {
            path = path.slice(0, -1);
        }
        return path;
    });
    return `${base}/${paths.join('/')}`;
}
export function arrayBufferToBase64(buffer) {
    const bufferAsString = arrayBufferToString(buffer);
    return window.btoa(bufferAsString);
}
export function arrayBufferToString(buffer) {
    return String.fromCharCode.apply(null, Array.from(new Uint8Array(buffer)));
}
export function base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}
export function formatDate(date) {
    return date.toISOString().split('.')[0] + 'Z';
}
export function convertSecondsToTimeSpan(value) {
    const days = Math.floor(value / (60 * 60 * 24));
    value -= days * (60 * 60 * 24);
    const hours = Math.floor(value / (60 * 60));
    value -= hours * (60 * 60);
    const mins = Math.floor(value / 60);
    value -= mins * 60;
    const seconds = Math.floor(value);
    value -= seconds;
    return `${days}.${hours}:${mins}:${seconds}`;
}
export function isValidTimeZone(tz) {
    try {
        Intl.DateTimeFormat(undefined, { timeZone: tz });
        return true;
    }
    catch (ex) {
        return false;
    }
}
export function isJsonResponse(response) {
    var _a;
    return !!((_a = response.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.includes('json'));
}
